import React, {useEffect} from 'react'
import {useForm} from "react-hook-form";
import Card from "../../components/forms/Card";
import FormGroup from "../../components/forms/FormGroup";
import Input from "../../components/forms/FormEl";
import {Col, Row} from "../../components/flex/FlexLayout";
import Button from "../../components/forms/Button";
import GrupoRiesgoFormSelect from "../../components/selects/GrupoRiesgoFormSelect";
const RiskForm = ({value, onSubmit}) => {

  const {register, handleSubmit, formState: {errors}, reset} = useForm(
    {defaultValues: value}
  );

  useEffect(() => {
    if (value) {
      reset(value)
    }
  }, [value])

  return (
    <form>
      <Card padding>

        <FormGroup>
          <label>Grupo de riesgo</label>
          <GrupoRiesgoFormSelect {...register("grupoRiesgoId", {required: "Campo obligatorio"})}/>
          {errors.grupoRiesgoId && <p style={{color: 'red'}}>{errors.grupoRiesgoId?.message}</p>}
        </FormGroup>

      </Card>

      <Card padding>

        <FormGroup>
          <label>Riesgo</label>
          <Input type='text' {...register("riesgo", {required: "Campo obligatorio"})}/>
          {errors.riesgo && <p style={{color: 'red'}}>{errors.riesgo?.message}</p>}
        </FormGroup>

        <Row>
          <Col>
            <FormGroup>
              <label>Valor si</label>
              <Input type='number' {...register("valorSi",
                {
                  required: "Campo obligatorio",
                  validate: value => (value.toString() === '0' || value.toString() === '1') || "El valor debe ser 0 o 1"
                })}/>
              {errors.valorSi && <p style={{color: 'red'}}>{errors.valorSi?.message}</p>}
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <label>Ajuste edad (Meses)</label>
              <Input type='number' {...register("ajusteEdad", {required: "Campo obligatorio"})}/>
              {errors.ajusteEdad && <p style={{color: 'red'}}>{errors.ajusteEdad?.message}</p>}
            </FormGroup>

          </Col>
        </Row>

        <FormGroup>
          <label>Recomendación</label>
          <Input type='text' {...register("recomendacion", {required: "Campo obligatorio"})}/>
          {errors.recomendacion && <p style={{color: 'red'}}>{errors.recomendacion?.message}</p>}
        </FormGroup>
      </Card>

      <Button variant={'primary'} onClick={handleSubmit(onSubmit)}>Guardar</Button>
    </form>
  )
}

export default RiskForm;
